import React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import withStyles from '@mui/styles/withStyles';
import {theme} from '../../Theme';

const styles = () => ({
  bidmiiRadio: {
    '&.MuiFormControlLabel-root': {
      marginBottom: 4,
      padding: '6px 0',
      minHeight: 48,

      '& .MuiTypography-body1': {
        marginTop: 2,
        fontSize: 15,
        fontFamily: 'AeonikProReqular !important',
      },
    },
  },
});

function BidmiiRadio(props: $TSFixMe) {
  const {classes} = props;

  return (
    <FormControlLabel
      key={props.key}
      control={
        <Radio
          onChange={props.onChange || undefined}
          checked={props.state === props.value}
          disabled={props.disabled}
          style={{
            color:
              props.state === props.value
                ? props.color || theme.palette.blue.main
                : theme.palette.gray.medium,
          }}
        />
      }
      value={props.value}
      label={props.label || undefined}
      labelPlacement={props.labelPlacement || undefined}
      className={classes.bidmiiRadio}
      style={props.style}
    />
  );
}

export default withStyles(styles)(BidmiiRadio);
